import {
    Dialog,
    DialogBody,
    DialogDisclosure,
    DialogDismiss,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Text} from '@/components/ui/text/Text'
import {Trans, useTranslation} from '@/translations/i18n'
import {View} from '../../types'
import {Button} from '@/components/ui/button/Button'
import {toast} from '@/utilities/toast/toast'
import {useDeleteView} from '../../queries/useDeleteView'
import {errorHandler} from '@/utilities/helpers'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {StyledFooter} from './style'
import {useSearchParams} from 'react-router-dom'

export const DeleteViewDialog = ({view, trigger}: {view: View; trigger: React.ReactElement}) => {
    const {t} = useTranslation()
    const [searchParams, setSearchParams] = useSearchParams()
    const deleteViewMutation = useDeleteView({
        onSuccess: () => {
            if (searchParams.get('view') == view.id) {
                setSearchParams('')
            }
            toast.success(t('commons:view_deleted'))
        },
        onError: errorHandler
    })

    return (
        <DialogProvider>
            <DialogDisclosure render={trigger} />
            <Dialog width="400px">
                <DialogBody gap={2}>
                    <Text render="h1" size="textXl" weight={'500'}>
                        {t('commons:delete_view')}
                    </Text>
                    <Text size="textMd" palette="neutral" shade="600">
                        <Trans
                            i18nKey="commons:view_delete_confirm"
                            values={{name: view.name}}
                            components={{br: <br />}}
                        />
                    </Text>
                </DialogBody>
                <StyledFooter>
                    <DialogDismiss render={<Button variant="secondary">{t('commons:cancel')}</Button>} />
                    <Button
                        variant="primaryDanger"
                        onClick={() => deleteViewMutation.mutate({urlParams: {id: view.id}})}
                        disabled={deleteViewMutation.isPending}
                    >
                        {view.visibility == View.shape.visibility.enum.public
                            ? t('commons:delete_view_public')
                            : t('commons:delete')}
                        {deleteViewMutation.isPending && <Spinner />}
                    </Button>
                </StyledFooter>
            </Dialog>
        </DialogProvider>
    )
}
